//
//
//
//
//
//

import Vue from 'vue';
import ImageZoom from './image-zoom';
import forEach from '../../utils/forEach';

export default {
    data: function data() {
        return {
            imageZoom: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.initZoom();
        forEach(this.images, function (index, image) {
            image.addEventListener('click', function (e) {
                _this.image.src = e.currentTarget.src;
                _this.imageZoom.kill();
                _this.initZoom();
            });
        });
    },


    computed: {
        image: function image() {
            return this.$parent.$refs.image;
        },
        images: function images() {
            return this.$parent.$refs.images.querySelectorAll('img');
        },
        container: function container() {
            return this.$parent.$refs.imageContainer;
        }
    },

    methods: {
        initZoom: function initZoom() {
            this.imageZoom = new ImageZoom(this.container, {
                width: this.image.width,
                height: this.image.height,
                scale: 2,
                offset: {
                    vertical: 0,
                    horizontal: 0
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/image-zoom/ImageZoom.vue
// module id = null
// module chunks = 